var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9C6.67 9 6.8125 8.9425 6.9275 8.8275C7.0425 8.7125 7.1 8.57 7.1 8.4C7.1 8.23 7.0425 8.0875 6.9275 7.9725C6.8125 7.8575 6.67 7.8 6.5 7.8C6.33 7.8 6.1875 7.8575 6.0725 7.9725C5.9575 8.0875 5.9 8.23 5.9 8.4C5.9 8.57 5.9575 8.7125 6.0725 8.8275C6.1875 8.9425 6.33 9 6.5 9ZM5.9 6.6H7.1V3H5.9V6.6ZM6.5 12C5.67 12 4.89 11.8425 4.16 11.5275C3.43 11.2125 2.795 10.785 2.255 10.245C1.715 9.705 1.2875 9.07 0.9725 8.34C0.6575 7.61 0.5 6.83 0.5 6C0.5 5.17 0.6575 4.39 0.9725 3.66C1.2875 2.93 1.715 2.295 2.255 1.755C2.795 1.215 3.43 0.7875 4.16 0.4725C4.89 0.1575 5.67 0 6.5 0C7.33 0 8.11 0.1575 8.84 0.4725C9.57 0.7875 10.205 1.215 10.745 1.755C11.285 2.295 11.7125 2.93 12.0275 3.66C12.3425 4.39 12.5 5.17 12.5 6C12.5 6.83 12.3425 7.61 12.0275 8.34C11.7125 9.07 11.285 9.705 10.745 10.245C10.205 10.785 9.57 11.2125 8.84 11.5275C8.11 11.8425 7.33 12 6.5 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleWhite);
export default __webpack_public_path__ + "static/media/Exclamation_circle_white.f3fac76e214a9c807d5a6f16d421bf50.svg";
export { ForwardRef as ReactComponent };